// Components
import CustomerAssurance from "@/components/CustomerAssurance/CustomerAssurance";
import { FormWrapper } from "@/components/Forms/FormWrapper";
import FeaturesList from "@/components/FeaturesList/FeaturesList";
import OrderSummary from "@/components/OrderSummary/OrderSummary";
import ProductList from "@/components/ProductList/ProductList";

export default function Checkout() {
  return (
    <>
      <OrderSummary className="md:hidden" />
      <main className="max-w-body mx-auto mb-6 flex flex-col gap-6 px-4 md:mt-10 md:mb-10 md:flex-row">
        <div className="flex flex-1 flex-col gap-6">
          <FeaturesList />
          <ProductList />
          <CustomerAssurance className="hidden md:flex" />
        </div>
        <div className="flex flex-1 flex-col gap-6">
          <OrderSummary className="hidden md:flex" />
          <FormWrapper />
          <CustomerAssurance className="md:hidden" />
        </div>
      </main>
    </>
  );
}
